export const topTabBarItemStyles = {
  height: 53,
  paddingVertical: 0,
  marginTop: 6,
};
